import * as Yup from 'yup';

export default Yup.object().shape({
  username: Yup.string().required('username required'),
  password: Yup.string().required('password required'),
});
